import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/_layout/booking/$bookingRef')({
  beforeLoad: ({ params }) => {
    throw redirect({ params, replace: true, to: '/mes-reservations/$bookingRef' })
  },
})
